import { Action } from "../../../types/state/action";

type ValueOrNull<T> = T | null;

export type MasterArtworkSearch = {
  artworkLevel: any;

  searchCollection:ValueOrNull<string>
  searchMetaArtwork:ValueOrNull<string>
  searchPrintingTechnique:ValueOrNull<string>

  appliedFiltersCollection: any;
  appliedFiltersMetaArtwork: any;
  appliedFiltersPrintingTechnique: any;

  currentPageCollection:number;
  currentPageMetaArtwork:number;
  currentPagePrintingTechnique:number;

  responseDataCollection:ValueOrNull<any[]>;
  responseDataMetaArtwork:ValueOrNull<any[]>;
  responseDataPrintingTechnique:ValueOrNull<any[]>;

  limitCollection:number
  limitMetaArtwork:number
  limitPrintingTechnique:number

};

export enum MasterArtworkSearchActionTypes {
  SET_ARTWORK_LEVEL = "masterArtworkSearchAction/setArtworkLevel",
  SET_SEARCH_COLLECTION = "masterArtworkSearchAction/setSearchCollection",
  SET_SEARCH_META_ARTWORK = "masterArtworkSearchAction/setSearchMetaArtwork",
  SET_SEARCH_PRINTING_TECHNIQUE = "masterArtworkSearchAction/setSearchPrintingTechnique",
  SET_APPLIED_FILTERS_COLLECTION = "masterArtworkSearchAction/setAppliedFiltersCollection",
  SET_APPLIED_FILTERS_META_ARTWORK = "masterArtworkSearchAction/setAppliedFiltersMetaArtwork",
  SET_APPLIED_FILTERS_PRINTING_TECHNIQUE = "masterArtworkSearchAction/setAppliedFiltersPrintingTechnique",
  SET_CURRENT_PAGE_COLLECTION = "masterArtworkSearchAction/setCurrentPageCollection",
  SET_CURRENT_PAGE_META_ARTWORK = "masterArtworkSearchAction/setCurrentPageMetaArtwork",
  SET_CURRENT_PAGE_PRINTING_TECHNIQUE = "masterArtworkSearchAction/setCurrentPagePrintingTechnique",
  SET_RESPONSE_DATA_COLLECTION = "masterArtworkSearchAction/setResponseDataCollection",
  SET_RESPONSE_DATA_META_ARTWORK = "masterArtworkSearchAction/setResponseDataMetaArtwork",
  SET_RESPONSE_DATA_PRINTING_TECHNIQUE = "masterArtworkSearchAction/setResponseDataPrintingTechnique",
  SET_LIMIT_COLLECTION = "masterArtworkSearchAction/setLimitCollection",
  SET_LIMIT_META_ARTWORK = "masterArtworkSearchAction/setLimitMetaArtwork",
  SET_LIMIT_PRINTING_TECHNIQUE = "masterArtworkSearchAction/setLimitPrintingTechnique"
}


export type MasterArtworkSearchActionType = Action<
  MasterArtworkSearchActionTypes,
  Partial<MasterArtworkSearch>
>;
